var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.625001 6.98366C0.624524 6.59768 0.789973 6.2302 1.07907 5.97512L7.57107 0.25229C8.01849 -0.123902 8.68381 -0.073387 9.06955 0.366064C9.4553 0.805515 9.42038 1.47316 8.9909 1.8698L3.31389 6.874C3.28237 6.90168 3.26429 6.94165 3.26429 6.98366C3.26429 7.02566 3.28237 7.06563 3.31389 7.09332L8.9909 12.0975C9.28973 12.3488 9.42931 12.7425 9.35561 13.1263C9.28192 13.5102 9.00652 13.8239 8.63599 13.9462C8.26545 14.0684 7.85791 13.9799 7.57106 13.715L1.0814 7.99395C0.791602 7.73843 0.625367 7.37045 0.625001 6.98366Z",
    fill: "#9A9693"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousArrow);
export default __webpack_public_path__ + "static/media/previous-arrow.88e3b46c3e3a5224464da8215e274576.svg";
export { ForwardRef as ReactComponent };